<template>
    <div class="my_order">
        <div class="tab">
            <div :class="dealType==0?'ac':''" @click="getList(0)">交易中</div>
            <div :class="dealType==2?'ac':''" @click="getList(2)">我发布的</div>
            <div :class="dealType==1?'ac':''" @click="getList(1)">交易完成</div>
        </div>
        <div></div>
        <div class="list">
            <div class="item" v-for="(item,index) in myPublish" :key="index" @click="goOrderDetails(item)">
                <div>
                    <span v-if="item.showType=='竞拍'" class="red">竞拍</span>
                    <span v-if="item.showType=='意向'" class="green">意向卖货</span>
                </div>
                <div class="fz18 fwB c333">{{item.title}}</div>
                <div>
                    <div class="c666">总量<span class="blue">{{item.allAmount}}</span>{{item.numUnit}}</div>
                    <div class="c999">更新时间 {{item.createDate|homeTime}}</div>
                </div>
                <div class="c666">
                    <div v-if="item.showType=='竞拍'"><span
                            class="fz18 fwB red">¥{{item.price?item.price:item.reservePrice}}</span>（当前最高价）</div>
                    <div v-if="item.showType=='竞拍'">竞拍底价<span
                            class="fz18 fwB green">¥{{item.reservePrice}}</span>/{{item.unitedTitle?item.unitedTitle:'吨'}}
                    </div>
                    <div v-if="item.showType=='意向'"><span class="fz18 fwB origin"><label v-if="item.price!='0'">¥</label>{{item.price=='0'?'面议':item.price}}</span>（底价）</div>
                </div>
            </div>
        </div>
        <div class="page" style="width: 100%;">
            <el-pagination @current-change="handleCurrentChange" background :current-page="pageNum" :page-size="12"
                layout="prev, pager, next" :total="total">
            </el-pagination>
            <input type="text" name="" id="" v-model="num" />
            <el-button size="mini" style="margin-left: 16px;" @click="inputCurrentChange">跳转</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MyOrder",
        data() {
            return {
                dealType: 0,
                myPublish: [],

                total: 0,
                pageNum: 1,
                num: null,
            }
        },
        created() {
            if (this.$route.query.type) {
                this.getList(this.$route.query.type);
            } else {
                this.getList(0);
            }
        },
        methods: {
            goOrderDetails(item) {
                let that = this;
                let path = '';
                let dealType = '';
                if (this.dealType == 0) {
                    if (item.showType == '竞拍') {
                        dealType = 'B';
                        path = '/order_jp';
                    }
                    that.$router.push({
                        path: path,
                        query: {
                            orderId: item.orderId,
                            dealType: dealType,
                            userId: item.oUserId,
                        }
                    });
                }
                if (this.dealType == 1) {
                    if (item.showType == '意向') {
                        dealType = 'YXNH';
                        path = '/order_yxmh';
                    }
                    if (item.showType == '竞拍') {
                        path = '/order_jp';
                        dealType = 'B';
                    }
                    that.$router.push({
                        path: path,
                        query: {
                            orderId: item.orderId,
                            dealType: dealType,
                            userId: item.oUserId,
                        }
                    });
                }
                if (this.dealType == 2) {
                    if (item.audit == 0 || !item.audit) {
                        this.$message({
                            message: '该发布审核未通过',
                            type: 'warning'
                        });
                        return;
                    }
                    if (item.showType == '意向') {
                        path = '/shop_yxmh_details_sell';
                    }
                    if (item.showType == '竞拍') {
                        path = '/shop_jp_details_sell';
                    }
                    that.$router.push({
                        path: path,
                        query: {
                            commodityId: item.id
                        }
                    });
                }
            },
            inputCurrentChange() {
                if (!this.num) {
                    return;
                }
                this.pageNum = this.num / 1;
                this.getList(this.dealType);
            },
            handleCurrentChange(pageNum) {
                this.pageNum = pageNum;
                this.getList(this.dealType);
            },
            getList(dealType) {
                this.pageNum = 1;
                this.dealType = dealType;
                this.getMyPublish(dealType);
            },
            getMyPublish(dealType) {
                this.request.get(this.$store.state.httpUrl + "mobileInterf/queryMyOrder1", {
                    params: {
                        dealType: dealType,
                        userId: this.$store.state.userId,
                        pageNum: 1,
                        pageSize: 10,
                        payType: '',
                        deliveryMethod: '',
                        productId: '',
                        shipTo: '',
                        status: '',
                        audit: '',
                        domestic: '',
                        qualityGoods: '',
                        qualityGoodsOne: ''
                    }
                }).then(res => {
                    if (res.status == 200) {
                        this.myPublish = res.data;
                        this.total = res.total;
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .my_order {
        padding: 0 24px;
    }

    .tab {
        display: flex;
        font-size: 18px;
        color: #333333;
        line-height: 70px;
        border-bottom: 1px solid #E6E6E6;
    }

    .tab>div {
        margin-right: 48px;
        cursor: pointer;
    }

    .tab>.ac {
        font-weight: bold;
        color: #D70606;
    }

    .list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .item {
        width: 418px;
        height: 162px;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        border-radius: 5px;
        box-sizing: border-box;
        font-size: 14px;
        padding: 0 24px;
        text-align: left;
        margin-top: 24px;
    }

    .item>div {
        margin-top: 14px;
    }

    .item>div:nth-child(1) {
        border-bottom: 1px solid #C7C7C7;
        line-height: 40px;
        margin-top: 0;
    }

    .item>div:nth-child(3),
    .item>div:nth-child(4) {
        display: flex;
    }

    .item>div:nth-child(3)>div:nth-child(2),
    .item>div:nth-child(4)>div:nth-child(2) {
        margin-left: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/me/myOrder.vue